<template>
  <div class="total-teacher-container">
    <div class="total-header">
      <p>Total Employees</p>
    </div>

    <div class="total-content-outer">
      <!-- <table>
        <tr>
          <td>Teachers</td>
          <td>36</td>
        </tr>
        <tr>
          <td>Employees</td>
          <td>20</td>
        </tr>
        <tr>
          <td>Total</td>
          <td>56</td>
        </tr>
      </table> -->

      <table>
        <tr>
          <td>Teachers</td>
          <td>{{ totalEmoloyees.total_teachers }}</td>
        </tr>

        <tr>
          <td>Employees</td>
          <td>{{ totalEmoloyees.total_non_teachers }}</td>
        </tr>

        <tr>
          <td><strong>Total</strong></td>
          <td><strong>{{ totalEmoloyees.total_employees }}</strong></td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
  import { ref, reactive, onMounted, onUnmounted, watch, watchEffect, computed, nextTick } from 'vue'
  import axios from 'axios'

  import { getSchoolData, getBranchData } from '@/composables/global'

  export default {
    props: {
      totalEmoloyees: { type: Object, default: () => ({}) }
    },

    setup (props, { emit }) {
      return {
      }
    }
  }
</script>

<style lang="scss">
  .total-teacher-container {
    position: relative;

    .total-header {
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 16px;
      background-color: #152751;

      p {
        width: 100%;
        text-align: center;
        font-size: 16px;
        line-height: 24px;
        font-weight: 600;
        color: white;
      }
    }

    .total-content-outer {
      width: 100%;
      height: calc(100% - 40px);
      padding: 0 16px;
      overflow-y: auto;

      table {
        width: 100%;
        border-collapse: collapse;

        tr {
          border-collapse: collapse;

          td {
            border-collapse: collapse;
            padding: 4px 0;
            vertical-align: bottom;
            border-bottom: 1px solid lightgray;

            &:nth-child(1) {
              width: 100px;
              font-size: 14px;
              line-height: 20px;
              font-weight: 600;
              color: gray;
            }

            &:nth-child(2) {
              width: calc(100% - 100px);
              font-size: 24px;
              line-height: 32px;
              font-weight: 600;
              color: black;
              text-align: right;
            }
          }

          &:nth-last-child(1) {
            td {
              border-bottom: none;
            }
          }

          &:hover {
            td {
              background-color: transparent;
            }
          }
        }
      }
    }
  }
</style>
